<app-header icon="back" title="_BackgroundThemes_" backText="_Details_" showNav="false"></app-header>
<div class="edit-theme-info-container body-container">
  <span class="theme-header">{{'_ImageAndTheme_' | translate}}</span>
  <app-add-edit-themes></app-add-edit-themes>
</div>
<div class="footer">
  <button mat-button (click)="openPreview()">{{'_PreviewActivity_' | translate}}</button>
  <button mat-button (click)="updateTheme()">Done</button>
</div>
